import { components } from 'react-select';

import { Divider } from '../../../../../Divider';
import { SelectOptionProps } from '../../SelectOption.types';
import { MenuProps } from './Menu.types';
import { useStyles } from './Menu.styles';

export const Menu = ({ children, ...rest }: MenuProps) => {
  const { error, footer, menuIsOpen } = rest.selectProps as unknown as SelectOptionProps;

  const styles = useStyles({
    menuPlacement: rest.placement,
    error,
    menuIsOpen,
  });

  const innerProps = {
    ...rest.innerProps,
    'data-testid': 'select_option__menu',
  } as React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement>;

  return (
    <components.Menu css={styles.root} {...rest} innerProps={innerProps}>
      <div css={styles.dividerContainer}>
        <Divider />
      </div>
      {children}
      {footer && <div css={styles.footerContainer}>{footer}</div>}
    </components.Menu>
  );
};
